import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
// import DashboardCalendar from "../dashboard/DashboardCalendar";
import PostComments from "./PostComments";
import OverlayContainer from "../../../Overlay/OverlayContainer";
import ReplyModal from "./ReplyModal";
import "./forum.scss";
import DashboardCalendar from "../../DashboardCalendar";

export default function Forums() {
  const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

  const [fetchStatusJustAddedCourse, setFetchStatusJustAddedCourse] =
    useState(true);
  const [isloading, setIsLoading] = useState(true);
  const [dataIndex, setDataIndex] = useState(5);
  const [forumId, setForumId] = useState(0);

  const [forumsHeaderDetails, setForumsHeaderDetails] = useState(null);
  const [userAskQuestionsModalPopup, setUserAskQuestionsModalPopUp] =
    useState(false);
  const [studentPurchasedCourseDetails, setStudentPurchaseCourseDetails] =
    useState();
  const [forumsInterrogate, setForumsInterrogate] = useState();
  useEffect(() => {
    axiosInstance
      .get("/course/purchased")
      .then((res) => {
        setStudentPurchaseCourseDetails(res?.data?.data.data);
        setFetchStatusJustAddedCourse(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    fetchUserForumPosts();
  }, []);

  const fetchUserForumPosts = () => {
    axiosInstance
      .get(`${REACT_APP_PAYMENT_API_BASEURL}/forum`)
      .then((res) => {
        setForumsInterrogate(res.data.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const forumAskQueryActionHandler = () => {
    setUserAskQuestionsModalPopUp(!userAskQuestionsModalPopup);
  };

  return (
    <div className="container-wrapper">
      <div className="dashboard-container-new studentDashboard-Data">
        <p>Forum {forumsHeaderDetails && forumsHeaderDetails}</p>

        <div className="forum-heading-dropdown">
          <div className="pagination-select">
            <select
              className="select-dropdown-instructor-2"
              style={{ border: "none" }}
            >
              <option value="">By Courses</option>
              <option value="0">Artificial Intelligence</option>
              <option value="1">Machine Learning</option>
            </select>
          </div>

          <div className="pagination-select">
            <select
              className="select-dropdown-instructor-2"
              style={{ border: "none" }}
            >
              <option value="">Latest First</option>
              <option value="0">1 week ago</option>
              <option value="1">1 month ago</option>
            </select>
          </div>
        </div>

        <div className="forum-heading">
          <button
            className="ask-question"
            onClick={() => forumAskQueryActionHandler()}
          >
            Ask Questions
          </button>
        </div>
      </div>

      <div className="dashboard-main">
        <div className="flex-80 forum-comment">
          <div>
            {isloading ? (
              <Loading />
            ) : forumsInterrogate && forumsInterrogate?.length > 0 ? (
              forumsInterrogate?.map((item) => (
                <PostComments
                  setForumsInterrogate={setForumsInterrogate}
                  element={item}
                  setForumsHeaderDetails={setForumsHeaderDetails}
                  studentPurchasedCourseDetails={studentPurchasedCourseDetails}
                  fetchUserForumPosts={fetchUserForumPosts}
                  forumId={forumId}
                  setForumId={setForumId}
                />
              ))
            ) : (
              <div className="no-forum-found">
                <span className="recordNotFound">No Data Found</span>
              </div>
            )}
          </div>
        </div>
        <div className="flex-20">
          <div className="box-shadow-new-01">
            <p className="paragraph-css">Just added Courses</p>
            {fetchStatusJustAddedCourse && (
              <div className="admindata-loading">
                <Loading />
              </div>
            )}
            {studentPurchasedCourseDetails &&
              studentPurchasedCourseDetails.length > 0 &&
              studentPurchasedCourseDetails
                .slice(0, dataIndex)
                .map((ele, index) => (
                  <div className="avator-padding-bottom" key={index}>
                    <div className="new-profile-flex new-profile-flex-70">
                      <div>
                        <p className="profile-data justAddedCourse">
                          {`${ele.CourseName.substring(0, 25)}...`}
                        </p>
                        <p className="profile-data-1">{ele.instructorName}</p>
                      </div>
                    </div>
                    <div className="new-profile-flex-15">
                      <p className="data-paragraph-css">15hr</p>
                      <p className="data-paragraph-css">{ele.EnrollmentFee}</p>
                    </div>
                  </div>
                ))}
            {studentPurchasedCourseDetails &&
              studentPurchasedCourseDetails.length > 5 && (
                <div
                  className="studentViewAllRecords"
                  onClick={() =>
                    setDataIndex(
                      studentPurchasedCourseDetails && dataIndex === 5
                        ? studentPurchasedCourseDetails.length
                        : 5
                    )
                  }
                >
                  {dataIndex === 5 ? "View All" : "View Less"}
                </div>
              )}
          </div>
          <div className="box-shadow-new-01 eventCalendarStatus">
            <p className="paragraph-css pb-15">Event Calendar</p>
            <DashboardCalendar />
          </div>
        </div>
      </div>
      {userAskQuestionsModalPopup && (
        <OverlayContainer>
          <ReplyModal
            studentPurchasedCourseDetails={studentPurchasedCourseDetails}
            getForumRecords={fetchUserForumPosts}
            userAskQuestionsModalPopup={userAskQuestionsModalPopup}
            forumAskQueryActionHandler={forumAskQueryActionHandler}
            fetchUserForumPosts={fetchUserForumPosts}
            forumId={forumId}
            setForumId={setForumId}
          />
        </OverlayContainer>
      )}
    </div>
  );
}
